import { Crosshair, Globe, Headphones, PlayCircle, Settings, Shield, Wifi, Zap } from 'lucide-react';

const ICON_MAP: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  zap: Zap,
  crosshair: Crosshair,
  headphones: Headphones,
  'play-circle': PlayCircle,
  settings: Settings,
  wifi: Wifi,
  globe: Globe,
  shield: Shield,
};

export function ToolIcon({ name, className, style }: { name: string; className?: string; style?: React.CSSProperties }) {
  const Icon = ICON_MAP[name] ?? Zap;
  return <Icon className={className} style={style} />;
}
